import { _ASSET_TYPE, createAssetEntity, getToken, getUrl } from "@rhinov/asset-manager-service";
import { Events, eventsManager, JoineryType, TechnicalElementType } from "@rhinov/savane-js";

export class DecorationService {

    // CONSTANTS
    FILTERS_CHANGE = 'decoService_request_filter_change'; //Event fired when filters are updated
    FILTERS_TAB_CHANGED = 'decoService_current_tab_updated'; //Event fired when a new tab is selected
    ASK_FILTERS = 'ask_for_filters_event';
    RESULTS_UPDATE = 'results_update_datas';
    // Group for request type
    group: string = _ASSET_TYPE.ARRANGEMENTS;
    // Filters field
    filters: null | string = null;
    cacheFilters: null | string = null;
    // usedInProject state
    usedInProject = false;
    // Request aborter
    aborter = new AbortController();
    // Designer filter current tab id
    tabId: string | null = null;
    // displayGroups state
    displayGroups = false;
    // Timeout for request
    timeout: ReturnType<typeof setTimeout> | null = null;

    isUserAllowedToManageAssetsGroupsList = false;
    // These are the minimal fields we want to get from the DB
    OPTIMIZED_DB_FIELDS = '&fields=kind,stockInfo,isNewProduct,supply,marketName,reference,price,genericName,name,randomization,isHpFloorGenerator,hpFloorGeneratorSettings,dimensions,displayDimensions,sketchBlock,_id,marketLink,configs,colors,stretchability,objectType,coatingType,type,hang,technicalElementType,manufacturer,retailer,joineryType,rse,pipeline.quality,pipeline.state,pipeline.modelState,styles,objectTypeConfig,zones,customization,universes,pipeline.unrealState,rhinovFormat,marketStatus,saleState';
    postSortFunction?: Function | null;

    static getInstance() {
        const g = globalThis as any;
        if (!g.__rhinov_DecorationService_instance) {
            new DecorationService();
        }
        return g.__rhinov_DecorationService_instance;
    }
    constructor() {
        (globalThis as any).__rhinov_DecorationService_instance = this;
    }

    /**
     *
     * @param selectedAsset
     */
    setAsset(selectedAsset: any) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        let assetType = this.group; //FIXME Retrieve in filters the group
        //FIXME this is dirty to decorate object coming from asset manager
        //Embed token to retrieve asset data
        selectedAsset.token = getToken();
        selectedAsset.url = getUrl() + 'api/v1/assets/';
        //force choosen index
        //Retrieve config
        selectedAsset.choosenIndex = this.getFilteredConfig(selectedAsset);

        // Transform asset type if it is asset_type.all, redirect towards correct asset
        if (assetType === _ASSET_TYPE.ALL) {
            switch (selectedAsset.kind) {
                case 'Arrangement':
                    assetType = _ASSET_TYPE.ARRANGEMENTS;
                    break;

                case 'Coating':
                    assetType = _ASSET_TYPE.COATINGS;
                    break;
            }
        }
        if (assetType == _ASSET_TYPE.PRODUCTS) {
            assetType = _ASSET_TYPE.ARRANGEMENTS
        }

        switch (assetType) {
            case _ASSET_TYPE.ARRANGEMENTS:
            case _ASSET_TYPE.TEMPLATES:
                // Object to create, let's switch to the pseudo edit mode of decoration to drop it
                createAssetEntity(assetType, selectedAsset, true, function (entity: any) {
                    // ETT Obligé d'ajouter ça pour que les groupes s'ajoutent correctement dans les étages (sinon la floorheight est potentiellement < 0 ce qui fait vriller l'ajout via web GL)
                    if (assetType === _ASSET_TYPE.TEMPLATES) {
                        entity.floorHeight = 0.01;
                    }
                    eventsManager.instance.dispatch(Events.ENTITY_EDITION, { entity: entity });
                });
                break;

            case _ASSET_TYPE.COATINGS:
                // Coating to apply on a wall or on a floor
                createAssetEntity(assetType, selectedAsset, true, function (entity: any) {
                    // Add go to DragCoatingState
                    eventsManager.instance.dispatch(Events.COATING_DRAG, { entity: entity, coating: selectedAsset });
                });
                break;

            case _ASSET_TYPE.JOINERIES:
                // Joinery to apply on an existing joinery (replace its 3D model)
                createAssetEntity(assetType, selectedAsset, true, function (entity: any) {
                    // Create a joinery element here (will be temporary and will be destroyed in DragComponentState)
                    let joineryComponent = new JoineryType(selectedAsset._id, undefined, undefined);
                    // Add go to DragComponentState
                    eventsManager.instance.dispatch(Events.JOINERY_COMPONENT_DRAG, { entity: entity, joineryComponent: joineryComponent });
                });
                break;

            case _ASSET_TYPE.TECHNICAL_ELEMENTS:
                // Technical element to apply on an existing technical element (replace its 3D model)
                createAssetEntity(assetType, selectedAsset, true, function (entity: any) {
                    // Create a technical element here (will be temporary and will be destroyed in DragComponentState)
                    let technicalComponent = new TechnicalElementType(selectedAsset._id);
                    // Add go to DragComponentState
                    eventsManager.instance.dispatch(Events.TECHNICAL_ELEMENT_COMPONENT_DRAG, { entity: entity, technicalComponent: technicalComponent });
                });
                break;

            case 'nextobjects':
            case 'magicsearch':
                switch (selectedAsset.kind) {
                    case 'Arrangement':
                        // Object to create, let's switch to the pseudo edit mode of decoration to drop it
                        createAssetEntity(_ASSET_TYPE.ARRANGEMENTS, selectedAsset, true, function (entity: any) {
                            eventsManager.instance.dispatch(Events.ENTITY_EDITION, { entity: entity });
                        });
                        break;

                    case 'Template':
                        // Object to create, let's switch to the pseudo edit mode of decoration to drop it
                        createAssetEntity(_ASSET_TYPE.TEMPLATES, selectedAsset, true, function (entity: any) {
                            eventsManager.instance.dispatch(Events.ENTITY_EDITION, { entity: entity });
                        });
                        break;

                    case 'Joinery':
                        // Joinery to apply on an existing joinery (replace its 3D model)
                        createAssetEntity(_ASSET_TYPE.JOINERIES, selectedAsset, true, function (entity: any) {
                            // Create a joinery element here (will be temporary and will be destroyed in DragComponentState)
                            let joineryComponent = new JoineryType(selectedAsset._id, undefined, undefined);
                            // Add go to DragComponentState
                            eventsManager.instance.dispatch(Events.JOINERY_COMPONENT_DRAG, { entity: entity, joineryComponent: joineryComponent });
                        });
                        break;

                    case 'TechnicalElement':
                        // Technical element to apply on an existing technical element (replace its 3D model)
                        createAssetEntity(_ASSET_TYPE.TECHNICAL_ELEMENTS, selectedAsset, true, function (entity: any) {
                            // Create a technical element here (will be temporary and will be destroyed in DragComponentState)
                            let technicalComponent = new TechnicalElementType(selectedAsset._id);
                            // Add go to DragComponentState
                            eventsManager.instance.dispatch(Events.TECHNICAL_ELEMENT_COMPONENT_DRAG, { entity: entity, technicalComponent: technicalComponent });
                        });
                        break;

                    case 'Coating':
                        // Coating to apply on a wall or on a floor
                        createAssetEntity(_ASSET_TYPE.COATINGS, selectedAsset, true, function (entity: any) {
                            // Add go to DragCoatingState
                            eventsManager.instance.dispatch(Events.COATING_DRAG, { entity: entity, coating: selectedAsset });
                        });
                        break;
                }
                break;
        }
    };

    /**
     * Return config filtered using relative filter in current item filters
     * @param selectedAsset
     */
    getFilteredConfig(selectedAsset: any) {
        let i: number, j: number; //iterator

        if (this.filters === null) {
            return 1;
        }

        let filtersSorted = this.filters.split('&q.');
        let configFilters: { value: null | string, chain: any[] }[] = [];

        for (i = 0; i < filtersSorted.length; i++) {
            if (filtersSorted[i].indexOf('configs.') === 0) {
                let _filter: { value: null | string, chain: any[] } = {
                    value: null, //Value to compare with
                    chain: [] //Path of attributes leading to value
                };

                //format filter
                let cutFilter = filtersSorted[i].split('.');
                //First item is 'configs' and last is '{method}={value}'
                //The rest is the path of attributes to the designated value
                for (j = 0; j < cutFilter.length; j++) {
                    if (j != 0) { //Ignore 'configs'
                        if (j >= cutFilter.length - 1) { //Value '{method}={value}'
                            _filter.value = cutFilter[j].split('=')[1]; //retrieve value
                        }
                        else {
                            _filter.chain.push(cutFilter[j]); //Add item to attribute chain
                        }
                    }
                }
                configFilters.push(_filter);
            }
        }

        //Use item to filter in config
        //FIXME Handle AM item without configs
        for (i = 0; selectedAsset.configs !== undefined && i < selectedAsset.configs.length; i++) {
            let config = selectedAsset.configs[i];
            let matchConfig = true; //bolean use to say if for now the item match the config, as soon as it goes to false the loop can be stopped

            for (j = 0; j < configFilters.length && matchConfig; j++) {
                let k = 0;
                let filter = configFilters[j];
                let chainedValue = config;

                while (k < filter.chain.length && chainedValue !== undefined) {
                    chainedValue = chainedValue[filter.chain[k]]; //Use chain to go deeped in attributes
                    k++;
                }

                if (chainedValue === undefined || chainedValue === null) {
                    matchConfig = false;
                }
                else {
                    let found = false;
                    let splitValue = filter.value?.split(',');

                    for (k = 0; k < splitValue!.length; k++) {
                        if (chainedValue === splitValue![k] || chainedValue._id === splitValue![k]) {
                            found = true;
                        }
                    }
                    if (!found) {
                        matchConfig = false;
                    }
                }
            }

            if (matchConfig) {
                //Match all filters
                return i + 1; //Return config index (+1 because config id start to 1)
            }

        }
        return 1;
    };

    /**
     * Update filters value
     * @parma group {Object} Represent the type of request (assset, template, coating ...)
     * @param filters {String} Formated filters to be send with the request to asset manager
     */
    setFilters(group: any, filters: string | null, postSortFunction?: Function | null) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        if (filters) {
            this.group = group;
            if (this.cacheFilters !== null && this.cacheFilters === this.filters) {
                this.filters = filters;
            } else {
                this.cacheFilters = this.filters;
                this.filters = filters;
            }
        }
        this.postSortFunction = postSortFunction;
        eventsManager.instance.dispatch(this.FILTERS_CHANGE, null);
    };

    /**
     * Process request with thne current page and limit
     * @param page
     */
    getResourcesIssues(idsListStr: string): Promise<any> {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);

        const url = getUrl() + 'api/v1/issues?fields=asset,status,visibility&q.asset.in=' + idsListStr + '&q.status.in=open,unresolvable&q.visibility.nin=content-factory&apikey=' + getToken();

        let promise = new Promise<any>((resolve) => {
            fetch(url).then(res => {
                res.status === 200 ? resolve(res.json()) : resolve(null);
            }).catch(_err => resolve(null));
        });
        return promise;
    };

    /**
     * Process request with thne current page and limit
     * @param page
     */
    loadResources = (page: number, limit: number, callback: any) => {
        if (!this.filters) {
            callback(null, null);
            return;
        }
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);

        if (this.aborter) {
            this.aborter.abort();
        }
        this.aborter = new AbortController();

        let url = getUrl();

        if (this.group === 'magicsearch') {
            url = getUrl() + 'services/freesearches';
        }
        else if (this.group === 'nextobjects') {
            url = getUrl() + 'api/smart/next';
        }
        else if (this.filters.indexOf('&color=') !== -1) {
            url = getUrl() + 'services/searches/any';
        } else {
            url = getUrl() + 'api/v1/' + this.group;
        }

        url += '?page=' + page + '&limit=' + limit + this.OPTIMIZED_DB_FIELDS;

        let filters = this.filters.slice(0);
        let assetIds: string[] | undefined | null = null;
        if (this.group !== 'nextobjects') {
            let params = new URLSearchParams(filters);
            if (params.get("q._id.in")) {
                assetIds = params.get("q._id.in")?.split(',');
                params.delete("q._id.in");
                filters = params.toString();
            }
            if (filters[0] !== '&') url += '&';
            url += filters;
        }

        url += '&apikey=' + getToken();

        // Get the results of the filter change in ascending order of the updatedAt field. We also get only the fields we want to optimize the DB access
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        let urls: string[] = [];
        const chunkAssetSize = 50;
        if (assetIds) {
            while (assetIds.length > 0) {
                let assets: string[] = [];
                for (let i = 0; i < chunkAssetSize; ++i) {
                    if (assetIds.length > 0) {
                        let assetId = assetIds.shift();
                        if (assetId !== undefined) {
                            assets.push(assetId);
                        }
                    } else {
                        break;
                    }
                }
                urls.push(url + '&q._id.in=' + assets.join(","));
            }
        } else {
            urls.push(url);
        }

        const fetchRequest = () => {
            const options: any = {
                method: this.group === 'nextobjects' ? 'POST' : 'GET',
                signal: this.aborter.signal
            };

            if (this.group === 'nextobjects') {
                options.headers = {
                    'Content-Type': 'application/json',
                    'Authorization': undefined
                };
                options.body = JSON.stringify(this.filters);
            }

            let promises: any[] = [];
            for (let i = 0; i < urls.length; ++i) {
                promises.push(fetch(urls[i], options));
            }

            Promise.all(promises).then(async results => {
                eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
                let datas: any = null;
                for (let i = 0; i < results.length; ++i) {
                    let result: any = results[i];
                    if (result.status === 200) {
                        let data = await result.json();
                        if (datas === null) {
                            datas = data;
                        } else {
                            datas.resources = datas.resources.concat(data.resources);
                        }
                    }
                }
                eventsManager.instance.dispatch(this.RESULTS_UPDATE, datas);
                callback(datas, url);
            }).catch((err) => {
                if (err.name !== 'AbortError') console.error('Error fetching data:', err);
                eventsManager.instance.dispatch(this.RESULTS_UPDATE, null);
                callback(null, url);
            });
        };

        this.timeout = setTimeout(() => {
            this.timeout = null;
            eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
            fetchRequest();
        }, 500);
    };
};

// For IIFE/global mode — manually attach to window
/*if (typeof window !== 'undefined') {
    // Set the class directly on the global scope
    (window as any).DecorationService = DecorationService;
}*/
